<!--sidebar-->
<c-sidebar
  #sidebar1="cSidebar"
  class="d-print-none sidebar sidebar-fixed border-end"

  id="sidebar1"
  visible
>
  <c-sidebar-header class="border-bottom">
    <div class="sidebar-brand d-flex align-items-center w-100">
      <span class="fw-semibold text-uppercase text-truncate" style="font-size: 1.1rem; letter-spacing: 0.05em; color: var(--cui-sidebar-color);">
        {{ tenantName }}
      </span>
    </div>
  </c-sidebar-header>

  <ng-scrollbar pointerEventsMethod="scrollbar" visibility="hover">
    <c-sidebar-nav [navItems]="navItems" dropdownMode="close" compact />
  </ng-scrollbar>

  @if (!sidebar1.narrow) {
    <c-sidebar-footer cSidebarToggle="sidebar1" class="border-top d-none d-lg-flex" toggle="unfoldable" style="cursor: pointer;">
      <button cSidebarToggler [attr.aria-label]="'layout.toggleSidebarFold' | transloco"></button>
    </c-sidebar-footer>
  }
</c-sidebar>

<!--main-->
<div class="wrapper d-flex flex-column min-vh-100">
  <!--app-header-->
  <app-default-header
    [cShadowOnScroll]="'sm'"
    class="mb-4 d-print-none header header-sticky p-0 shadow-sm"
    position="sticky"
    sidebarId="sidebar1"
  />
  <!--app-body-->
  <div class="body flex-grow-1">    
    <c-container [breakpoint]="isFluidLayout() ? null : 'lg'" [fluid]="isFluidLayout()" class="h-auto px-4">
      <app-report-currency />
      <router-outlet />
    </c-container>
  </div>
  <!--app footer-->
  <app-default-footer />
</div>
